import { Divider, Grid } from "@mui/material";
import { useContext } from "react";
import { categoryName } from "../../../constants";
import { PageContext } from "../../../SettingsView";
import CustomNotificationPage from "../../CustomNotificationPage";
import CriticalAssetsNotificationsSection from "./CriticalAssetsNotificationsSection";
import IntegrationsNotificationsSection from "./IntegrationsNotificationsSection";
import InventoryNotificationsSection from "./inventoryNotificationsSection/InventoryNotificationsSection";

const PageContent = () => {
  const [currentCategory] = useContext(PageContext);

  return (
    <>
      <Grid item>
        <CriticalAssetsNotificationsSection />
      </Grid>
      <Grid item>
        <Divider />
      </Grid>
      <Grid item>
        <IntegrationsNotificationsSection />
      </Grid>
      {currentCategory === categoryName.PERSONAL && (
        <>
          <Grid item>
            <Divider />
          </Grid>

          <Grid item>
            <InventoryNotificationsSection />
          </Grid>
        </>
      )}
    </>
  );
};

export default function AssetsNotificationsPage() {
  return <CustomNotificationPage title="Assets" PageComponent={PageContent} />;
}
